// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-preferred -> price-brothers-preferred -> deer-creek-apartment-homes
// Generated: 2026-11-03T22:58:43.154Z
// Counts: 2 design, 93 content, 17 slot group, 3 collection binding, 6 section, 2 style

export const designOverrides = {
  "design._site.font.heading": {
    "cssVariable": "--vibe-font-heading",
    "overrideType": "VALUE",
    "value": "'Montserrat', sans-serif",
    "mappedField": null
  },
  "design._site.color.linkUnderline": {
    "cssVariable": "--vibe-color-link-underline",
    "overrideType": "VALUE",
    "value": "underline",
    "mappedField": null
  }
};

export const contentOverrides = {
  "accessibilityhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Accessibility</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Everyday Comforts. A Little Something Extra</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.apartmentHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Apartment Features</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.communityHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Community Amenities</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "applynowhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Apply Now</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form_title": {
    "overrideType": "VALUE",
    "customValue": "Test",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form.form_header_text": {
    "overrideType": "VALUE",
    "customValue": "Schedule",
    "generatedValue": null,
    "mappedField": null
  },
  "contacthero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Contact Us</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "ctasection.card1.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Choose from our spacious <span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> bedroom floor plans.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "faqhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Frequently Asked Questions</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "fees.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Find Your Space at Deer Creek</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Make Yourself at Home</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.address": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "footer.copyright": {
    "overrideType": "VALUE",
    "customValue": "© 2026 All Rights Reserved.",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "gallery.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "gallery.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "google-tag-manager.container_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_google_gtm_id"
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apartments in Overland Park, KS at Deer Creek</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2><span data-type=\"field-token\" data-field=\"property_name\"></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/luxury-apartments-pool-oklahoma-city::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Enjoy luxury living with a pool at Liberty Pointe in Oklahoma City. Discover the perfect blend of comfort and luxury in our beautiful community.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/luxury-apartments-pool-oklahoma-city::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Luxury Apartments with Pool in OKC</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactivemaphero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Interactive Map</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "json-ld-schema.override_phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "neighborhoodcallout.description": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_neighborhood_blurb"
  },
  "neighborhoodcallout.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>A Convenient Address on Metcalf Avenue</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Your Neighborhood. Your Next Adventure</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodmap.category_order": {
    "overrideType": "VALUE",
    "customValue": "Shopping & Retail, Education, Entertainment, Health and Wellness, Nature & Outdoor Attractions, Transportation & Transit, Major Employers & Offices, Restaurants",
    "generatedValue": null,
    "mappedField": null
  },
  "pageblurb.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "pageblurb.scheduler.header_text": {
    "overrideType": "VALUE",
    "customValue": "Schedule",
    "generatedValue": null,
    "mappedField": null
  },
  "pagehero.subtitle": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "pagehero.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicyhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>A Place for You and Your Pets</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacypolicyhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Privacy Policy</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertycontactinfo.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "propertyoverview.pre_title": {
    "overrideType": "VALUE",
    "customValue": "<p>Your Search Ends Here</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Your Space. Your Style. Your Home</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "rentgrata-widget.property_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_rentgrata_token"
  },
  "residentaccesshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Resident Access</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewscallout.title": {
    "overrideType": "VALUE",
    "customValue": "<h3>What Residents Say About <span data-type=\"field-token\" data-field=\"property_name\"></span></h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Reviews</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-blurb.scheduler_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-tour-scheduler",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduleatourhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Come See What Makes Deer Creek Special</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemaphero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Sitemap</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "thankyouhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Thank You</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "virtualtourhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore Your Next Home From Anywhere</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "_head.favicon_url": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_company_icon"
  },
  "accessibilityhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Our commitment to accessible living at <span data-type=\"field-token\" data-field=\"property_name\"></span> in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieshero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apartment Amenities in Overland Park, KS</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "applynowhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Begin your application for <span data-type=\"field-token\" data-field=\"property_name\"></span> in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "contacthero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Contact Deer Creek Apartment Homes</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "faqhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Quick answers about leasing, amenities, and life at <span data-type=\"field-token\" data-field=\"property_name\"></span> in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanshero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>1, 2 &amp; 3 Bedroom Apartments in Overland Park, KS</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "galleryhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Photos of Our Apartments in Overland Park, KS</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "galleryhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Inside Deer Creek Apartment Homes</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/in-unit-laundry-apartments-denton-tx::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Discover modern living at Eastpark with in-unit laundry. Enjoy ultimate convenience in Denton, TX, where comfort meets stylish amenities.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/in-unit-laundry-apartments-denton-tx::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apartments with In-Unit Laundry in Denton, TX</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactivemaphero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Discover the neighborhood surrounding <span data-type=\"field-token\" data-field=\"property_name\"></span> in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apartments on Metcalf Avenue Near 135th Street</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "onebedroomhero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>1 Bedrooms</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.restrictions": {
    "overrideType": "VALUE",
    "customValue": "<p>Restrictions: Aggressive dog breeds including, but not limited to, Pit Bull, American Staffordshire Terrier, Rottweiler, German Shepherd, Malamute, Doberman Pinscher, Chow, Great Dane, Saint Bernard, Akita, Wolf Hybrid, and any mixed breed that includes the aforementioned, are specifically prohibited and Landlord has discretion to limit other breeds. Inherently dangerous or exotic, feral or wild animals are prohibited.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicyhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Pet-Friendly Apartments in Overland Park, KS</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferred-employer-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Price Brothers Management Co. is proud to offer a Preferred Employer Program at <span data-type=\"field-token\" data-field=\"property_name\"></span>! Team members of participating companies receive waived application and administrative fees, making it even easier to call our community home. Have questions or want to see if you qualify? Contact our team—we’re here to help!</p><p>Program details and eligibility are subject to change at any time. Applicants must provide valid proof of employment with an approved Preferred Employer and meet all standard application requirements.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferredemployerbenefits.benefits_heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Program Benefits</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferredemployercta.callout_body": {
    "overrideType": "VALUE",
    "customValue": "<p>Take the next step toward calling <span data-type=\"field-token\" data-field=\"property_name\"></span> home — apply today and enjoy the benefits of our exclusive discount program!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferredemployercta.callout_title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Ready to Redeem This Offer?</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferredemployerhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Exclusive Savings for Local Professionals at <span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferredemployerhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Preferred Employer Program</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferredemployerlist.footnote": {
    "overrideType": "VALUE",
    "customValue": "<p><em>Program details and eligibility are subject to change at any time. Applicants must provide valid proof of employment with an approved Preferred Employer and meet all standard application requirements.</em></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferredemployerlist.heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Our Preferred Employer Partners</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacypolicyhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>How <span data-type=\"field-token\" data-field=\"property_name\"></span> collects, uses, and protects your information</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "residentaccesshero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Resident portal login and account tools for <span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewshero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>What residents are saying about living at <span data-type=\"field-token\" data-field=\"property_name\"></span> in <span data-type=\"field-token\" data-field=\"property_address_city\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduleatourhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Schedule Your Tour of Deer Creek Apartment Homes</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "sister-properties-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Explore nearby communities from Price Brothers Management Co. — each with its own character, amenities, and floor plans.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "sisterpropertieshero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Nearby Communities From Price Brothers Management Co.</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "sisterpropertieshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore More Places to Call Home</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemaphero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Browse all pages on the <span data-type=\"field-token\" data-field=\"property_name\"></span> website</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "studioshero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Studio Apartments in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "studioshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Studios</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "thankyouhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Thank you for reaching out to <span data-type=\"field-token\" data-field=\"property_name\"></span>—we will be in touch soon</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "townhomes-floor-plans.empty_message": {
    "overrideType": "VALUE",
    "customValue": "<p>There are no townhomes listed right now. Explore all of our floor plans or contact us for upcoming availability.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtualtourhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Virtual Tours of Deer Creek Apartment Homes</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Your four-legged companions are welcome at Deer Creek Apartment Homes! Our pet-friendly apartments in Overland Park, KS offer spacious layouts, private patios and balconies, and a nature path for enjoying a leashed stroll with your dog.</p><p>We welcome cats and dogs, with up to two pets permitted per apartment home. Have questions about pet fees, breed restrictions, or the <a class=\"richtext-link\" href=\"https://www.pricebrotherskc.com/petroyaltyclub/\" target=\"_blank\">Price Brothers Pet Royalty Club</a>? Our <a class=\"richtext-link\" href=\"/contact-us\">leasing team</a> can share more information.</p><h2></h2><h2>Assistance Animals</h2><p>Assistance animals are not considered pets and are not subject to standard pet fees, pet deposits, or breed restrictions. Requests for reasonable accommodations involving assistance animals are reviewed individually in accordance with applicable Fair Housing laws.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferredemployerlist.employers": {
    "overrideType": "VALUE",
    "customValue": "<ul><li><p>Cerner</p></li><li><p>T-Mobile</p></li><li><p>Black &amp; Veatch</p></li><li><p>Honeywell</p></li><li><p>St. Luke's South Hospital</p></li><li><p>Overland Park Police Department</p></li><li><p>Active Military</p></li><li><p>All Price Brothers Commercial Tenants</p></li></ul>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "amenitieslist.community_photo_5": {
    "sourceIndex": 8,
    "fieldOverrides": null
  },
  "footer.design_by_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Repli Logo"
      }
    }
  },
  "pagehero.bg_image": {
    "sourceIndex": 6,
    "fieldOverrides": null
  },
  "featuredfloorplan.view_all_cta": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Apply Now"
      },
      "url": {
        "type": "VALUE",
        "customValue": ""
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "header.schedule_tour_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/schedule-a-tour"
      }
    }
  },
  "preferredemployercta.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_apply_now_url"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      },
      "label": {
        "type": "VALUE",
        "customValue": "Apply Now"
      }
    }
  },
  "ctasection.card1_image": {
    "sourceIndex": 1,
    "fieldOverrides": null
  },
  "ctasection.card2_image": {
    "sourceIndex": 10,
    "fieldOverrides": null
  },
  "ctasection.card3_image": {
    "sourceIndex": 26,
    "fieldOverrides": null
  },
  "floorplanslist.bg_pattern": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a1a20e-5b05-7058-893b-f6499a2952af.webp"
      },
      "tile_size": {
        "type": "VALUE",
        "customValue": "500"
      },
      "overlay_opacity": {
        "type": "VALUE",
        "customValue": "85"
      }
    }
  },
  "neighborhoodcallout.image_1": {
    "sourceIndex": 16,
    "fieldOverrides": null
  },
  "sisterproperties.community1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Sorrento at Deer Creek Apartment Homes"
      },
      "location": {
        "type": "GENERATOR",
        "generatedValue": "7700 W. 126th Terrace, Overland Park, KS 66213"
      },
      "addressUrl": {
        "type": "GENERATOR",
        "generatedValue": "https://www.google.com/maps/search/?api=1&query=7700+W+126th+Terrace+Overland+Park+KS+66213"
      },
      "url": {
        "type": "GENERATOR",
        "generatedValue": "https://www.sorrentoapartmentskc.com"
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Visit Community"
      },
      "_target": {
        "type": "GENERATOR",
        "generatedValue": "_blank"
      }
    }
  },
  "sisterproperties.community2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Wynnewood Farms"
      },
      "location": {
        "type": "GENERATOR",
        "generatedValue": "5433 W 133rd Terrace, Overland Park, KS 66209"
      },
      "addressUrl": {
        "type": "GENERATOR",
        "generatedValue": "https://www.google.com/maps/search/?api=1&query=5433+W+133rd+Terrace+Overland+Park+KS+66209"
      },
      "url": {
        "type": "GENERATOR",
        "generatedValue": "https://www.wynnewoodfarms.com"
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Visit Community"
      },
      "_target": {
        "type": "GENERATOR",
        "generatedValue": "_blank"
      }
    }
  },
  "sisterproperties.community3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Stonebriar Apartment Homes"
      },
      "location": {
        "type": "GENERATOR",
        "generatedValue": "12490 Quivira Rd, Overland Park, KS 66213"
      },
      "addressUrl": {
        "type": "GENERATOR",
        "generatedValue": "https://www.google.com/maps/search/?api=1&query=12490+Quivira+Rd+Overland+Park+KS+66213"
      },
      "url": {
        "type": "GENERATOR",
        "generatedValue": "https://www.stonebriarkc.com"
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Visit Community"
      },
      "_target": {
        "type": "GENERATOR",
        "generatedValue": "_blank"
      }
    }
  },
  "sisterproperties.community4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Crowne Chase Apartment Homes"
      },
      "location": {
        "type": "GENERATOR",
        "generatedValue": "11621 W. 118th Terrace, Overland Park, KS 66210"
      },
      "addressUrl": {
        "type": "GENERATOR",
        "generatedValue": "https://www.google.com/maps/search/?api=1&query=11621+W+118th+Terrace+Overland+Park+KS+66210"
      },
      "url": {
        "type": "GENERATOR",
        "generatedValue": "https://www.crownechase.com"
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Visit Community"
      },
      "_target": {
        "type": "GENERATOR",
        "generatedValue": "_blank"
      }
    }
  },
  "sisterproperties.community5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Creekside Apartment Homes"
      },
      "location": {
        "type": "GENERATOR",
        "generatedValue": "11920 Oakmont St, Overland Park, KS 66213"
      },
      "addressUrl": {
        "type": "GENERATOR",
        "generatedValue": "https://www.google.com/maps/search/?api=1&query=11920+Oakmont+St+Overland+Park+KS+66213"
      },
      "url": {
        "type": "GENERATOR",
        "generatedValue": "https://www.creeksideaptskc.com"
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Visit Community"
      },
      "_target": {
        "type": "GENERATOR",
        "generatedValue": "_blank"
      }
    }
  },
  "sisterproperties.community6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Stonebriar Woods Apartment Homes"
      },
      "location": {
        "type": "GENERATOR",
        "generatedValue": "12401 W. 120th St, Overland Park, KS 66213"
      },
      "addressUrl": {
        "type": "GENERATOR",
        "generatedValue": "https://www.google.com/maps/search/?api=1&query=12401+W+120th+St+Overland+Park+KS+66213"
      },
      "url": {
        "type": "GENERATOR",
        "generatedValue": "https://www.stonebriarwoods.com"
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Visit Community"
      },
      "_target": {
        "type": "GENERATOR",
        "generatedValue": "_blank"
      }
    }
  }
};

export const collectionBindingOverrides = {
  "amenitieslist.carousel_images": {
    "limit": 1,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "amenitieslist.items": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "propertyoverview.gallery_images": {
    "limit": 6,
    "hiddenIds": null,
    "orderedIds": [
      "ec_22c0583aad402f19a2bdc462",
      "ec_4fca1ec783aff4f34ea8b9ea",
      "ec_82d937a16070dde7a6980aa2",
      "ec_40648a3bb2fcbca112b45a97",
      "ec_2a885537d8e76a1c459fc066",
      "ec_a9e71df0e592415caf3ed9ab",
      "ec_989913cfbe67fc47a45df182",
      "ec_552e896bde1b50018a047714",
      "ec_956caa7896f42e7db40c0904",
      "ec_cd814429aab75ff066adcdf8"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "rentcafe-chatbot",
      "blockId": "rentcafe-chatbot",
      "position": 0
    }
  ],
  "interactive-map": [
    {
      "sectionId": "apartment-sync",
      "blockId": "apartment-sync-map",
      "position": 7
    }
  ]
};

export const styleOverrides = {
  "hero.subtitle": {
    "properties": {
      "textAlign": "center"
    }
  },
  "_section.block:apartment-sync-map": {
    "properties": {
      "paddingTop": "15px",
      "paddingRight": "15px",
      "paddingBottom": "15px",
      "paddingLeft": "15px",
      "backgroundColor": "#ffffff"
    }
  }
};
